import React from 'react';
import { Pane } from '@leverege/ui-elements';
import { GlobalState } from '@leverege/ui-redux';
import { Blocker } from '@leverege/molten/views';
import P from '@leverege/promise';
import { DataSources } from '@leverege/ui-attributes';
import { TheftRecoveryActive, TheftRecoveryInactive } from './views';
import TheftRecoveryEnding from './views/TheftRecoveryEnding';
import { theftRecoveryRequestStates as THEFT_RECOVERY_REQUEST_STATES } from '../../../constants';
import { jsx as _jsx } from "react/jsx-runtime";
export default class TheftRecoveryCard extends React.Component {
  constructor(props) {
    super(props);
    this.initialLoad = P.deferred();
    this.state = {
      caseData: null
    };
  }
  componentDidMount() {
    this.loadData();
  }
  componentDidUpdate(prevProps) {
    const prevItem = prevProps.sharedProps?.item;
    const {
      sharedProps: {
        item
      }
    } = this.props;
    if (prevItem?.data?.case?.id !== item?.data?.case?.id) {
      this.loadData();
    }
  }
  loadData() {
    this.loadCaseActions();
    if (this.caseActions) {
      GlobalState.dispatch(this.caseActions.get()).then(res => {
        this.setState({
          caseData: {
            id: res.id,
            data: res,
            ref: this.caseActions.parent().getInterfaceUrl(),
            type: 'case'
          }
        });
        this.initialLoad.resolve();
      }).catch(err => {
        this.initialLoad.resolve();
      });
    } else {
      this.initialLoad.resolve();
    }
  }
  loadCaseActions() {
    const {
      sharedProps: {
        item,
        actions
      }
    } = this.props;
    if (item?.data?.case?.id) {
      let ref = actions.getInterfaceUrl();
      if (ref.indexOf('vehicles') > -1) {
        ref = ref.replace('vehicles', 'cases');
        ref = ref.endsWith('cases') ? ref : trimRef(ref);
      } else if (ref.indexOf('vehicle')) {
        ref = ref.replace('vehicle', 'case');
        ref = ref.endsWith('case') ? ref : trimRef(ref);
      }
      const caseObj = {
        id: item.data.case.id,
        ref,
        type: 'case'
      };
      this.caseActions = DataSources.getActions(caseObj);
    }
  }
  renderChildren = () => {
    const {
      sharedProps: {
        item
      }
    } = this.props;
    const {
      caseData
    } = this.state;
    const theftRecoveryState = item?.data?.locator?.data?.theftRecoveryRequestMetadata?.state || 'ended';
    switch (theftRecoveryState) {
      case THEFT_RECOVERY_REQUEST_STATES.CREATED:
      case THEFT_RECOVERY_REQUEST_STATES.ACTIVATING:
      case THEFT_RECOVERY_REQUEST_STATES.ACTIVATED:
        return /*#__PURE__*/_jsx(TheftRecoveryActive, {
          ...this.props,
          caseActions: this.caseActions,
          caseData: caseData
        });
      case THEFT_RECOVERY_REQUEST_STATES.ENDING:
        return /*#__PURE__*/_jsx(TheftRecoveryEnding, {
          ...this.props,
          caseActions: this.caseActions,
          caseData: caseData
        });
      default:
        return /*#__PURE__*/_jsx(TheftRecoveryInactive, {
          ...this.props,
          caseActions: this.caseActions,
          caseData: caseData
        });
    }
  };
  render() {
    const matchContext = {
      client: 'WhyDoIHaveToDoThis'
    };
    return /*#__PURE__*/_jsx(Pane, {
      variant: "theftRecoveryCardContent",
      children: /*#__PURE__*/_jsx(Blocker, {
        matchContext: matchContext,
        context: this.props,
        hooks: [{
          execute: () => this.initialLoad
        }],
        render: this.renderChildren
      })
    });
  }
}
function trimRef(ref) {
  const arr = ref.split('/');
  arr.pop();
  return arr.join('/');
}